import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';


function CreateSingle() {    
    function handleSubmit(e) {
        e.preventDefault();
        window.wait().then(async () => {
            if (!window.app.tonConnectUI.account?.address) {
                alert('Connect wallet');
                return;
            }
            let modal1 = new window.bootstrap.Modal(document.getElementById('buy_1'));
            let modal2 = new window.bootstrap.Modal(document.getElementById('buy_2'));
            let modal3 = new window.bootstrap.Modal(document.getElementById('buy_3'));
            window.cb = (a) => {
                modal1.hide();
                modal2.show();
            };
            modal1.show();
            await window.app.submit();
            modal2.hide();
            modal3.show();
        });
    }

    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            <div class="no-bottom no-top" id="content">
                <div id="top"></div>

                <section id="subheader" class="text-dark">

                </section>


                <section aria-label="section" style={{ paddingTop: 0 }}>
                    <div class="container">
                        <div class="row wow fadeIn">
                            <div class="col-lg-3 col-sm-6 col-xs-12">


                                <h5>Preview</h5>
                                <div class="nft__item">
                                    <div class="author_list_pp">
                                    </div>
                                    <div class="nft__item_wrap">
                                        <p>Upload file and choose collection to preview your brand new NFT</p>
                                    </div>
                                    <div class="nft__item_info">

                                        <div class="nft__item_click">
                                        </div>
                                        <div class="nft__item_price">
                                        </div>
                                        <div class="nft__item_action">
                                        </div>
                                        <div class="nft__item_like">
                                        </div>
                                    </div>

                                </div>

                                {/*<!--<h5>Preview item</h5>
                            <div class="nft__item">
                                <div class="author_list_pp">
                                    <a href="#">                                    
                                        <img class="lazy" src="images/author/author-1.jpg" alt="">
                                        <i class="fa fa-check"></i>
                                    </a>
                                </div>
                                <div class="nft__item_wrap">
                                    <a href="#">
                                        <img src="images/collections/coll-item-3.jpg" id="get_file_2" class="lazy nft__item_preview" alt="">
                                    </a>
                                </div>
                                <div class="nft__item_info">
                                    <a href="#">
                                        <h4>Pinky Ocean</h4>
                                    </a>
                                    <div class="nft__item_click">
                                    <span></span>
                                </div>
                                <div class="nft__item_price">
                                        0.08 TON<span>1/20</span>
                                    </div>
                                    <div class="nft__item_action">
                                        <a href="#">Buy now </a>
                                    </div>
                                    <div class="nft__item_like">
                                        <i class="fa fa-heart"></i><span>50</span>
                                    </div>                            
                                </div> 
                            </div>-->*/}
                            </div>
                            <div class="col-lg-7 offset-lg-1">
                                {/* <a href="create.html" class="fw-semibold" style={{ color: 'black' }}><i class="fa fa-fw" aria-hidden="true" title="Collectible"></i> Manage collectible type</a> */}
                                <h1 class="pb-30 title-mt">Create single NFT</h1>
                                <form id="form-create-item" class="form-border" method="post" action="email.php">
                                    <div class="field-set">
                                        <h5>Upload file</h5>

                                        <div class="d-create-file">
                                            <p id="file_name">PNG, JPG, GIF, WEBP. Max 100mb.</p>
                                            <input type="button" id="get_file" class="btn-main" value="Browse" />
                                            <input type="file" id="upload_file" />
                                        </div>


                                        <div class="spacer-40"></div>

                                        <h5>Name</h5>
                                        <input type="text" name="item_title" id="item_title" class="form-control" placeholder="e.g. 'Crypto Funk" />

                                        <div class="spacer-20"></div>

                                        <h5>Description <span style={{ fontSize: '13px', color: 'darkgray' }}>(Optional)</span></h5>
                                        <textarea data-autoresize name="item_desc" id="item_desc" class="form-control" placeholder="e.g. 'This is very limited item'"></textarea>

                                        <div class="spacer-20"></div>

                                        <h5>Price</h5>
                                        <input type="text" name="item_royalties" id="item_price" class="form-control" placeholder="Fixed price for one item (TON)" />

                                        <div class="spacer-20"></div>

                                        <h5>Royalties for the artist</h5>
                                        <p class="p-info">Collect royalties every time your NFT is sold. The amount is deducted from the final sale price and sent to your address.
                                        </p>
                                        <input type="text" name="item_royalties" id="item_royalties" class="form-control" placeholder="suggested: 0, 10%, 20%, 30%. Maximum is 70%" />

                                        <div class="spacer-20"></div>

                                        <div class="switch-with-title" style={{ padding: 0, border: 'none' }}>
                                            <h5>Free minting</h5>
                                            <div class="de-switch">
                                                <input type="checkbox" id="switch-unlock" class="checkbox" />
                                                <label for="switch-unlock"></label>
                                            </div>
                                            <div class="clearfix"></div>
                                            <p class="p-info">Buyer will pay gas fees for minting.Your NFT won't be minted in blockchain. Your NFT will be stored for further minting by buyer

                                            </p>

                                        </div>

                                        {/*<!--<h5>Select method</h5>
                                    <div class="de_tab tab_methods">
                                        <ul class="de_nav">
                                            <li class="active"><span><i class="fa fa-tag"></i>Fixed price</span>
                                            </li>
                                            <li><span><i class="fa fa-hourglass-1"></i>Timed auction</span>
                                            </li>
                                            <li><span><i class="fa fa-users"></i>Open for bids</span>
                                            </li>
                                        </ul>

                                        <div class="de_tab_content">

                                            <div id="tab_opt_1">
                                                <h5>Price</h5>
                                                <input type="text" name="item_price" id="item_price" class="form-control" placeholder="enter price for one item (TON)" />
                                            </div>

                                            <div id="tab_opt_2">
                                                <h5>Minimum bid</h5>
                                                <input type="text" name="item_price_bid" id="item_price_bid" class="form-control" placeholder="enter minimum bid" />

                                                <div class="spacer-20"></div>

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <h5>Starting date</h5>
                                                        <input type="date" name="bid_starting_date" id="bid_starting_date" class="form-control" min="1997-01-01" />
                                                    </div>
                                                    <div class="col-md-6">
                                                        <h5>Expiration date</h5>
                                                        <input type="date" name="bid_expiration_date" id="bid_expiration_date" class="form-control" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="tab_opt_3">
                                            </div>

                                        </div>

                                    </div>-->*/}



                                        <div class="spacer-20"></div>

                                        <h5>Choose collection</h5>
                                        <p class="p-info">This is the collection where your item will appear. <span><a href="/create-collection" class="fw-semibold">Create new</a></span></p>

                                        <div id="item_collection" class="dropdown fullwidth mb20">
                                            <a href="#" class="btn-selector">Select Collection</a>
                                            <ul>
                                                <li><span>Abstraction</span></li>
                                                <li><span>Patternlicious</span></li>
                                            </ul>
                                        </div>
                                        {/* <div class="spacer-20"></div>
                                        <div class="switch-with-title">
                                            <h5><i class="fa fa- fa-unlock-alt id-color-2 icon_padlock"></i>Unlock once purchased</h5>
                                            <div class="de-switch">
                                                <input type="checkbox" id="switch-unlock" class="checkbox" />
                                                <label for="switch-unlock"></label>
                                            </div>
                                            <div class="clearfix"></div>
                                            <p class="p-info">Unlock content after successful transaction.</p>

                                            <div class="hide-content">
                                                <input type="text" name="item_unlock" id="item_unlock" class="form-control" placeholder="Access key, digital twin, code to redeem or link to a file,..." />
                                            </div>
                                        </div> */}
                                        <div class="spacer-20"></div>
                                        <div class="alert alert-secondary" role="alert">
                                            <b><span aria-hidden="true" class="icon_info"></span> It will be impossible the alter the NFT data.</b>
                                            <p class="p-info">Editing NFTs is currently unavailable, so it will not be possible to change any data after minting.
                                            </p>
                                        </div>
                                        <input type="button" id="submit" class="btn-main" value="Create Item" onClick={handleSubmit} />


                                    </div>
                                </form>
                            </div>


                        </div>
                    </div>
                </section>


                {/* <div class="go3872688706"><button class="go3758850101 go1318663305" data-tc-icon-button="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.71966 2.71968C3.01255 2.42678 3.48743 2.42677 3.78032 2.71966L8.00002 6.93925L12.2197 2.71967C12.5126 2.42677 12.9874 2.42678 13.2803 2.71967C13.5732 3.01257 13.5732 3.48744 13.2803 3.78033L9.06068 7.99991L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L8.00002 9.06057L3.78033 13.2803C3.48744 13.5732 3.01257 13.5732 2.71967 13.2803C2.42678 12.9874 2.42677 12.5126 2.71967 12.2197L6.93936 7.99991L2.71968 3.78034C2.42678 3.48745 2.42677 3.01257 2.71966 2.71968Z" fill="#909099"></path></svg></button><div class="go3799783513" data-tc-confirm-modal="true"><svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" class="go121314943"><path d="M24 56.7846C35.479 63.412 50.1572 59.479 56.7846 47.9999C63.412 36.5209 59.479 21.8427 48 15.2153C36.521 8.58791 21.8428 12.5209 15.2154 23.9999" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke="#434347"></path></svg><h1 class="go3525292397 go1539641740" data-tc-h1="true">Confirm the&nbsp;transaction in&nbsp;MyTonWallet</h1><div class="go1186201158 go4168504425" fontsize="14px" fontweight="510" lineheight="130%" color="#E5E5EA" data-tc-text="true" style="cursor: default;">It will only take a&nbsp;moment.</div></div></div> */}

                
                <div class="modal fade" id="buy_1" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered de-modal">
                        <div class="modal-content">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="modal-body">
                                <div class="p-3 form-border">
                                    <h3>Almost ready </h3>
                                    <b>Transaction</b>
                                    <div class="spacer-single"></div>
                                    <h6>Network fee : max 0,05 TON.<br />Go to the wallet app and confirm 2 transactions. <br />
                                    The first to mint the NFT, the second to register the sale contract.</h6>


                                    <div class="spacer-single"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="buy_2" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered de-modal">
                        <div class="modal-content">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="modal-body">
                                <div class="p-3 form-border">
                                <h3>Almost ready </h3>
                                <p>Payment received</p>
                                <b>Checking payment</b>
                                    <div class="spacer-single"></div>
                                    <h6>We are checking the payment. It may take some time.</h6>


                                    <div class="spacer-single"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="buy_3" tabindex="-1" aria-labelledby="buy_now" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered de-modal">
                        <div class="modal-content">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="modal-body">
                                <div class="p-3 form-border">
                                <h3>Your NFT has been officially minted.</h3>
                                    <div class="spacer-single"></div>
                                    <h6>Your NFT has been officially minted on the The Open Network blockchain and now is available on Gallery3 to view and purchase. </h6>


                                    <div class="spacer-single"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Footer component */}
            <Footer />

        </div>
    );
}

export default CreateSingle;